import Dimm from '@components/pass/interview/common/dimm';
import { useUserInfo } from '@repository/auth/useUserInfo';
import { useFrequencyQuestionList } from '@repository/interviewPractices/pooledQuestions/usePooledQuestions';
import useCheckAuthority from '@utils/hooks/useCheckAuthority';
import classnames from 'classnames/bind';
import InterviewPracticeQuestionList from '../../common/questionList';
import style from './frequency.module.scss';
const cx = classnames.bind(style);

const InterviewPracticeQuestionSelectBodyFrequency = () => {
  const { data: userInfo } = useUserInfo();
  const { isAuthorityUser } = useCheckAuthority(userInfo);
  const { data: frequencyQuestionList } = useFrequencyQuestionList({
    enabled: isAuthorityUser,
  });
  const frequencyQuestionCount = frequencyQuestionList?.questions.length;

  return (
    <div className={cx('frequencyWrap')}>
      <div className={cx('title')}>
        빈출 면접 질문
        {isAuthorityUser && (
          <>
            <span className={cx('highlightText')}>{frequencyQuestionCount}</span>개
          </>
        )}
      </div>
      {!isAuthorityUser && <Dimm style={{ width: 1200, height: 614 }} />}
      <InterviewPracticeQuestionList
        className={cx('questionList', 'frequencyList')}
        questionList={frequencyQuestionList?.questions ?? []}
      />
    </div>
  );
};

export default InterviewPracticeQuestionSelectBodyFrequency;
